{
  "level": "eb09",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb09",
    "objects": "AREAS.E3:eb09.e3",
    "mesh": "TREES.E3:eb09.e3"
  },
  "spawn_point": {
    "position": [
      1846.428237720246,
      1764.2925902454565,
      394.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1846.428237720246,
      1864.2925902454565,
      394.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1660.0,
      1579.9000244140625,
      370.0
    ],
    "bbox_max": [
      2020.0,
      1940.0999755859375,
      1150.0
    ],
    "vertex_count": 705,
    "vertices": [
      [
        2010.691162109375,
        1866.4083251953125,
        1100.0
      ],
      [
        2017.950927734375,
        1838.01513671875,
        1100.0
      ],
      [
        2008.5718994140625,
        1874.696533203125,
        370.0
      ],
      [
        1999.2861328125,
        1911.0142822265625,
        370.0
      ],
      [
        2014.4278564453125,
        1851.7933349609375,
        740.0
      ],
      [
        2014.4278564453125,
        1851.7933349609375,
        720.0
      ],
      [
        2017.950927734375,
        1838.01513671875,
        1125.0
      ],
      [
        2010.691162109375,
        1866.4083251953125,
        1125.0
      ],
      [
        2017.950927734375,
        1838.01513671875,
        1100.0
      ],
      [
        2017.950927734375,
        1838.01513671875,
        1125.0
      ],
      [
        2010.691162109375,
        1866.4083251953125,
        1125.0
      ],
      [
        2010.691162109375,
        1866.4083251953125,
        1100.0
      ],
      [
        1952.9219970703125,
        1929.09423828125,
        370.0
      ],
      [
        1990.959228515625,
        1919.3411865234375,
        370.0
      ],
      [
        2009.791748046875,
        1866.4083251953125,
        1125.0
      ],
      [
        2009.791748046875,
        1866.4083251953125,
        1100.0
      ],
      [
        2009.791748046875,
        1866.4083251953125,
        1100.0
      ],
      [
        2011.0001220703125,
        1865.199951171875,
        1100.0
      ],
      [
        2011.0001220703125,
        1865.199951171875,
        1125.0
      ],
      [
        2009.791748046875,
        1866.4083251953125,
        1125.0
      ],
      [
        1910.0,
        1830.0,
        370.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1910.0,
        1895.4892578125,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1956.5875244140625,
        1830.0,
        1150.0
      ],
      [
        1910.0,
        1876.693359375,
        1150.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1150.0
      ],
      [
        1910.0,
        1830.0,
        1150.0
      ],
      [
        1910.0,
        1876.693359375,
        1150.0
      ],
      [
        1968.064697265625,
        1837.4246826171875,
        1060.0
      ],
      [
        1975.4892578125,
        1830.0,
        1060.0
      ],
      [
        1917.3707275390625,
        1888.118408203125,
        1060.0
      ],
      [
        1910.0,
        1895.4891357421875,
        1060.0
      ],
      [
        1968.0645751953125,
        1837.4246826171875,
        1060.0
      ],
      [
        1917.3707275390625,
        1888.118408203125,
        1060.0
      ],
      [
        1961.243408203125,
        1830.0,
        1100.0
      ],
      [
        1940.134033203125,
        1830.0,
        1100.0
      ],
      [
        1910.0,
        1860.1337890625,
        1100.0
      ],
      [
        1910.0,
        1881.243408203125,
        1100.0
      ],
      [
        1910.0,
        1893.3603515625,
        1100.0
      ],
      [
        1910.0,
        1881.243408203125,
        1100.0
      ],
      [
        1973.3603515625,
        1830.0,
        1100.0
      ],
      [
        1961.243408203125,
        1830.0,
        1100.0
      ],
      [
        1913.6175537109375,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1833.6175537109375,
        1130.0
      ],
      [
        1910.0,
        1881.243408203125,
        1130.0
      ],
      [
        1910.0,
        1893.3603515625,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1961.243408203125,
        1830.0,
        1130.0
      ],
      [
        2012.184814453125,
        1838.01513671875,
        1125.0
      ],
      [
        2012.184814453125,
        1838.01513671875,
        1100.0
      ],
      [
        2012.184814453125,
        1838.01513671875,
        1125.0
      ],
      [
        1973.3603515625,
        1830.0,
        1130.0
      ],
      [
        1973.3603515625,
        1830.0,
        1100.0
      ],
      [
        1916.0584716796875,
        1891.7369384765625,
        1125.0
      ],
      [
        1937.271728515625,
        1912.9501953125,
        1125.0
      ],
      [
        1910.0,
        1893.3603515625,
        1130.0
      ],
      [
        1916.0584716796875,
        1891.7369384765625,
        1125.0
      ],
      [
        1910.0,
        1893.3603515625,
        1125.0
      ],
      [
        1910.0,
        1893.3603515625,
        1100.0
      ],
      [
        1975.800048828125,
        1830.0,
        1059.6484375
      ],
      [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1896.0,
        1060.0
      ],
      [
        1910.0,
        1896.0,
        1059.422119140625
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1060.0
      ],
      [
        1956.5875244140625,
        1830.0,
        1060.0
      ],
      [
        1910.0,
        1876.693359375,
        1060.0
      ],
      [
        1910.0,
        1830.0,
        1100.0
      ],
      [
        1910.0,
        1830.0,
        1130.0
      ],
      [
        1910.0,
        1860.753173828125,
        375.0
      ],
      [
        1940.753173828125,
        1830.0,
        375.0
      ],
      [
        1912.4688720703125,
        1830.0,
        375.0
      ],
      [
        1910.0,
        1832.4688720703125,
        375.0
      ],
      [
        1910.0,
        1832.4688720703125,
        380.0
      ],
      [
        1912.4688720703125,
        1830.0,
        380.0
      ],
      [
        1910.0,
        1830.0,
        380.0
      ],
      [
        1770.0,
        1830.0,
        370.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1704.5107421875,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1895.4892578125,
        1060.0
      ],
      [
        1770.0,
        1896.0,
        1059.422119140625
      ],
      [
        1723.412353515625,
        1830.0,
        1150.0
      ],
      [
        1770.0,
        1876.693359375,
        1150.0
      ],
      [
        1770.0,
        1830.0,
        1150.0
      ],
      [
        1723.412353515625,
        1830.0,
        1150.0
      ],
      [
        1770.0,
        1876.693359375,
        1150.0
      ],
      [
        1704.510498046875,
        1830.0,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1770.0,
        1895.489501953125,
        1060.0
      ],
      [
        1711.9351806640625,
        1837.4246826171875,
        1060.0
      ],
      [
        1762.629150390625,
        1888.1185302734375,
        1060.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      [
        1702.2049560546875,
        1830.0,
        1100.0
      ],
      [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      [
        1702.2049560546875,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      [
        1770.0,
        1924.4183349609375,
        1100.0
      ],
      [
        1770.0,
        1924.4183349609375,
        1100.0
      ],
      [
        1770.0,
        1897.7950439453125,
        1100.0
      ],
      [
        1770.0,
        1897.7950439453125,
        1130.0
      ],
      [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1893.3599853515625,
        1130.0
      ],
      [
        1770.0,
        1881.243408203125,
        1130.0
      ],
      [
        1718.756591796875,
        1830.0,
        1130.0
      ],
      [
        1766.382568359375,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1833.617431640625,
        1130.0
      ],
      [
        1718.756591796875,
        1830.0,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1130.0
      ],
      [
        1770.0,
        1893.3599853515625,
        1130.0
      ],
      [
        1770.0,
        1881.243408203125,
        1130.0
      ],
      [
        1706.639892578125,
        1830.0,
        1100.0
      ],
      [
        1770.0,
        1893.3599853515625,
        1100.0
      ],
      [
        1770.0,
        1881.243408203125,
        1100.0
      ],
      [
        1770.0,
        1860.134033203125,
        1100.0
      ],
      [
        1739.8658447265625,
        1830.0,
        1100.0
      ],
      [
        1718.7564697265625,
        1830.0,
        1100.0
      ],
      [
        1706.639892578125,
        1830.0,
        1100.0
      ],
      [
        1718.7564697265625,
        1830.0,
        1100.0
      ],
      [
        1770.0,
        1893.3599853515625,
        1100.0
      ],
      [
        1770.0,
        1881.243408203125,
        1100.0
      ],
      [
        1704.19970703125,
        1830.0,
        1060.0
      ],
      [
        1704.19970703125,
        1830.0,
        1059.6480712890625
      ],
      [
        1770.0,
        1896.0,
        1059.422119140625
      ],
      [
        1770.0,
        1896.0,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1876.693359375,
        1060.0
      ],
      [
        1723.412353515625,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1830.0,
        1060.0
      ],
      [
        1770.0,
        1876.693359375,
        1060.0
      ],
      [
        1770.0,
        1830.0,
        1100.0
      ],
      [
        1770.0,
        1830.0,
        1130.0
      ],
      [
        1739.246826171875,
        1830.0,
        375.0
      ],
      [
        1770.0,
        1860.753173828125,
        375.0
      ],
      [
        1770.0,
        1832.4688720703125,
        375.0
      ],
      [
        1767.5311279296875,
        1830.0,
        375.0
      ],
      [
        1767.5311279296875,
        1830.0,
        380.0
      ],
      [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      [
        1770.0,
        1830.0,
        380.0
      ],
      [
        1840.0,
        1830.0,
        370.0
      ],
      [
        1840.0,
        1830.0,
        370.0
      ],
      [
        1828.52392578125,
        1940.0999755859375,
        1130.0
      ],
      [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      [
        1832.501953125,
        1940.0999755859375,
        1100.0
      ],
      [
        1832.501953125,
        1940.0999755859375,
        1130.0
      ],
      [
        1832.501953125,
        1940.0999755859375,
        1130.0
      ],
      [
        1828.52392578125,
        1940.0999755859375,
        1130.0
      ],
      [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      [
        1832.501953125,
        1940.0999755859375,
        1100.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1150.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1150.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1799.58544921875,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1880.41455078125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.0
      ],
      [
        1799.58544921875,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.3406982421875
      ],
      [
        1799.58544921875,
        1830.0,
        1135.57080078125
      ],
      [
        1795.0,
        1837.9422607421875,
        1140.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1137.1920166015625
      ],
      [
        1880.41455078125,
        1830.0,
        1135.5706787109375
      ],
      [
        1840.0001220703125,
        1830.0,
        1130.3406982421875
      ],
      [
        1892.9425048828125,
        1830.0,
        1130.0
      ],
      [
        1885.0001220703125,
        1837.9423828125,
        1140.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1137.19189453125
      ],
      [
        1892.9425048828125,
        1830.0,
        1150.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1150.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1140.0
      ],
      [
        1880.41455078125,
        1830.0,
        1135.5706787109375
      ],
      [
        1787.0577392578125,
        1830.0,
        1140.0
      ],
      [
        1799.58544921875,
        1830.0,
        1135.57080078125
      ],
      [
        1782.045166015625,
        1927.6458740234375,
        1100.0
      ],
      [
        1782.045166015625,
        1927.6458740234375,
        1130.0
      ],
      [
        1782.045166015625,
        1927.6458740234375,
        1100.0
      ],
      [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      [
        1907.084716796875,
        1830.0,
        1100.0
      ],
      [
        1794.9998779296875,
        1837.9422607421875,
        1100.0
      ],
      [
        1840.000244140625,
        1850.0001220703125,
        1100.0
      ],
      [
        1840.000244140625,
        1850.0001220703125,
        1100.0
      ],
      [
        1885.000244140625,
        1837.9425048828125,
        1100.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1060.0
      ],
      [
        1885.000244140625,
        1837.9425048828125,
        1100.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1100.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1060.0
      ],
      [
        1787.0576171875,
        1830.0,
        1100.0
      ],
      [
        1794.9998779296875,
        1837.9422607421875,
        1100.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1106.0
      ],
      [
        1840.000244140625,
        1852.0001220703125,
        1106.0
      ],
      [
        1895.7908935546875,
        1837.05126953125,
        1106.0
      ],
      [
        1898.52294921875,
        1834.3192138671875,
        1106.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1106.0
      ],
      [
        1826.4776611328125,
        1853.6236572265625,
        1106.0
      ],
      [
        1830.2093505859375,
        1854.62353515625,
        1106.0
      ],
      [
        1840.000244140625,
        1852.0001220703125,
        1106.0
      ],
      [
        1820.6817626953125,
        1855.176513671875,
        1103.0
      ],
      [
        1824.413818359375,
        1856.176513671875,
        1103.0
      ],
      [
        1830.2093505859375,
        1854.62353515625,
        1106.0
      ],
      [
        1826.4776611328125,
        1853.6236572265625,
        1106.0
      ],
      [
        1901.58642578125,
        1835.498291015625,
        1103.0
      ],
      [
        1904.318359375,
        1832.766357421875,
        1103.0
      ],
      [
        1898.52294921875,
        1834.3192138671875,
        1106.0
      ],
      [
        1895.7908935546875,
        1837.05126953125,
        1106.0
      ],
      [
        1901.58642578125,
        1835.498291015625,
        1100.0
      ],
      [
        1904.318359375,
        1832.766357421875,
        1100.0
      ],
      [
        1904.318359375,
        1832.766357421875,
        1103.0
      ],
      [
        1901.58642578125,
        1835.498291015625,
        1103.0
      ],
      [
        1852.5001220703125,
        1846.6510009765625,
        1115.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1115.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6510009765625,
        1110.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1115.0
      ],
      [
        1872.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6510009765625,
        1110.0
      ],
      [
        1852.5001220703125,
        1846.6510009765625,
        1115.0
      ],
      [
        1781.4769287109375,
        1834.3187255859375,
        1106.0
      ],
      [
        1775.681396484375,
        1832.7657470703125,
        1100.0
      ],
      [
        1775.681396484375,
        1832.7657470703125,
        1103.0
      ],
      [
        1775.681396484375,
        1832.7657470703125,
        1103.0
      ],
      [
        1781.4769287109375,
        1834.3187255859375,
        1106.0
      ],
      [
        1791.267822265625,
        1836.9422607421875,
        1106.0
      ],
      [
        1791.267822265625,
        1836.9422607421875,
        1130.0
      ],
      [
        1787.0576171875,
        1830.0,
        1106.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      [
        1787.0576171875,
        1830.0,
        1106.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1106.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1130.0
      ],
      [
        1791.2679443359375,
        1836.9422607421875,
        1106.0
      ],
      [
        1787.0576171875,
        1830.0,
        1106.0
      ],
      [
        1784.32568359375,
        1830.0,
        1106.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1115.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1115.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1115.0
      ],
      [
        1784.6409912109375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      [
        1777.158203125,
        1830.0,
        1106.0
      ],
      [
        1772.9156494140625,
        1830.0,
        1103.0
      ],
      [
        1777.158203125,
        1830.0,
        1106.0
      ],
      [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      [
        1772.9156494140625,
        1830.0,
        1103.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1115.0
      ],
      [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1115.0
      ],
      [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      [
        1902.8421630859375,
        1830.0,
        1106.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1106.0
      ],
      [
        1907.084716796875,
        1830.0,
        1103.0
      ],
      [
        1902.8421630859375,
        1830.0,
        1106.0
      ],
      [
        1907.084716796875,
        1830.0,
        1100.0
      ],
      [
        1907.084716796875,
        1830.0,
        1103.0
      ],
      [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      [
        1884.1846923828125,
        1830.0,
        385.0
      ],
      [
        1788.7442626953125,
        1830.0,
        380.0
      ],
      [
        1891.2557373046875,
        1830.0,
        380.0
      ],
      [
        1788.7442626953125,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        390.0
      ],
      [
        1891.2557373046875,
        1830.0,
        390.0
      ],
      [
        1884.1846923828125,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        390.0
      ],
      [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      [
        1884.1846923828125,
        1830.0,
        390.0
      ],
      [
        1884.1846923828125,
        1830.0,
        385.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        370.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      [
        1770.0001220703125,
        1624.5106201171875,
        1060.0
      ],
      [
        1704.5108642578125,
        1689.9998779296875,
        1060.0
      ],
      [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1150.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1150.0
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1150.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1150.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1150.0
      ],
      [
        1711.935546875,
        1682.575439453125,
        1060.0
      ],
      [
        1704.5111083984375,
        1689.9998779296875,
        1060.0
      ],
      [
        1762.6292724609375,
        1631.881591796875,
        1060.0
      ],
      [
        1770.0001220703125,
        1624.5108642578125,
        1060.0
      ],
      [
        1711.935546875,
        1682.575439453125,
        1060.0
      ],
      [
        1762.6292724609375,
        1631.881591796875,
        1060.0
      ],
      [
        1766.3829345703125,
        1689.9998779296875,
        1130.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1130.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1130.0
      ],
      [
        1770.0001220703125,
        1686.3826904296875,
        1130.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1130.0
      ],
      [
        1770.0001220703125,
        1626.6397705078125,
        1130.0
      ],
      [
        1706.639892578125,
        1689.9998779296875,
        1130.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1130.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1100.0
      ],
      [
        1739.8663330078125,
        1689.9998779296875,
        1100.0
      ],
      [
        1770.0001220703125,
        1659.8660888671875,
        1100.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1100.0
      ],
      [
        1770.0001220703125,
        1626.6397705078125,
        1100.0
      ],
      [
        1770.0001220703125,
        1638.7567138671875,
        1100.0
      ],
      [
        1706.639892578125,
        1689.9998779296875,
        1100.0
      ],
      [
        1718.75634765625,
        1689.9998779296875,
        1100.0
      ],
      [
        1770.0001220703125,
        1626.6397705078125,
        1130.0
      ],
      [
        1770.0001220703125,
        1626.6397705078125,
        1100.0
      ],
      [
        1706.639892578125,
        1689.9998779296875,
        1130.0
      ],
      [
        1706.639892578125,
        1689.9998779296875,
        1100.0
      ],
      [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1704.1998291015625,
        1689.9998779296875,
        1060.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1060.0
      ],
      [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1060.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1060.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1060.0
      ],
      [
        1723.4122314453125,
        1689.9998779296875,
        1060.0
      ],
      [
        1770.0001220703125,
        1643.3067626953125,
        1060.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1100.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      [
        1770.0001220703125,
        1659.2467041015625,
        375.0
      ],
      [
        1739.2469482421875,
        1689.9998779296875,
        375.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        375.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        375.0
      ],
      [
        1770.0001220703125,
        1687.531005859375,
        380.0
      ],
      [
        1767.53125,
        1689.9998779296875,
        380.0
      ],
      [
        1770.0001220703125,
        1689.9998779296875,
        380.0
      ],
      [
        1910.0,
        1689.9998779296875,
        370.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1975.4891357421875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1150.0
      ],
      [
        1910.0,
        1643.306640625,
        1150.0
      ],
      [
        1910.0,
        1689.9998779296875,
        1150.0
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1150.0
      ],
      [
        1910.0,
        1643.306640625,
        1150.0
      ],
      [
        1975.4892578125,
        1689.9998779296875,
        1060.0
      ],
      [
        1968.064697265625,
        1682.5753173828125,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      [
        1968.064697265625,
        1682.5753173828125,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1595.58154296875,
        1130.0
      ],
      [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      [
        1910.0,
        1622.2049560546875,
        1130.0
      ],
      [
        1910.0,
        1595.58154296875,
        1130.0
      ],
      [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      [
        1910.0,
        1622.2049560546875,
        1100.0
      ],
      [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      [
        2004.4183349609375,
        1689.9998779296875,
        1100.0
      ],
      [
        1977.794921875,
        1689.9998779296875,
        1100.0
      ],
      [
        2004.4183349609375,
        1689.9998779296875,
        1100.0
      ],
      [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      [
        1977.794921875,
        1689.9998779296875,
        1130.0
      ],
      [
        1910.0,
        1626.639892578125,
        1130.0
      ],
      [
        1973.3599853515625,
        1689.9998779296875,
        1130.0
      ],
      [
        1910.0,
        1638.756591796875,
        1130.0
      ],
      [
        1961.2435302734375,
        1689.9998779296875,
        1130.0
      ],
      [
        1913.6173095703125,
        1689.9998779296875,
        1130.0
      ],
      [
        1910.0,
        1686.382568359375,
        1130.0
      ],
      [
        1910.0,
        1626.639892578125,
        1130.0
      ],
      [
        1910.0,
        1638.756591796875,
        1130.0
      ],
      [
        1961.2435302734375,
        1689.9998779296875,
        1130.0
      ],
      [
        1973.3599853515625,
        1689.9998779296875,
        1130.0
      ],
      [
        1910.0,
        1626.639892578125,
        1100.0
      ],
      [
        1973.3599853515625,
        1689.9998779296875,
        1100.0
      ],
      [
        1910.0,
        1638.7564697265625,
        1100.0
      ],
      [
        1910.0,
        1659.8660888671875,
        1100.0
      ],
      [
        1940.1339111328125,
        1689.9998779296875,
        1100.0
      ],
      [
        1961.2435302734375,
        1689.9998779296875,
        1100.0
      ],
      [
        1910.0,
        1626.639892578125,
        1100.0
      ],
      [
        1910.0,
        1638.7564697265625,
        1100.0
      ],
      [
        1973.3599853515625,
        1689.9998779296875,
        1100.0
      ],
      [
        1961.2435302734375,
        1689.9998779296875,
        1100.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1060.0
      ],
      [
        1975.8001708984375,
        1689.9998779296875,
        1059.6480712890625
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1060.0
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1956.5877685546875,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1910.0,
        1689.9998779296875,
        1100.0
      ],
      [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      [
        1940.7530517578125,
        1689.9998779296875,
        375.0
      ],
      [
        1910.0,
        1659.246826171875,
        375.0
      ],
      [
        1910.0,
        1687.5311279296875,
        375.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        375.0
      ],
      [
        1912.46875,
        1689.9998779296875,
        380.0
      ],
      [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      [
        1910.0,
        1689.9998779296875,
        380.0
      ],
      [
        1840.0,
        1689.9998779296875,
        370.0
      ],
      [
        1840.0,
        1689.9998779296875,
        370.0
      ],
      [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      [
        1851.4755859375,
        1579.9000244140625,
        1100.0
      ],
      [
        1847.498046875,
        1579.9000244140625,
        1100.0
      ],
      [
        1847.498046875,
        1579.9000244140625,
        1130.0
      ],
      [
        1851.4755859375,
        1579.9000244140625,
        1100.0
      ],
      [
        1847.498046875,
        1579.9000244140625,
        1100.0
      ],
      [
        1847.498046875,
        1579.9000244140625,
        1130.0
      ],
      [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1060.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1060.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1150.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1150.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1130.0
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1130.0
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.0
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1130.0
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1130.0
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1130.0
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.3408203125
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1135.57080078125
      ],
      [
        1885.0,
        1682.0577392578125,
        1139.9998779296875
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1137.19189453125
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1135.57080078125
      ],
      [
        1840.0,
        1689.9998779296875,
        1130.3408203125
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1130.0
      ],
      [
        1795.0,
        1682.0577392578125,
        1140.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1137.1920166015625
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1150.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1150.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1140.0
      ],
      [
        1799.58544921875,
        1689.9998779296875,
        1135.57080078125
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1140.0
      ],
      [
        1880.41455078125,
        1689.9998779296875,
        1135.57080078125
      ],
      [
        1897.95556640625,
        1592.354248046875,
        1100.0
      ],
      [
        1897.95556640625,
        1592.354248046875,
        1130.0
      ],
      [
        1897.95556640625,
        1592.354248046875,
        1100.0
      ],
      [
        1907.0843505859375,
        1689.9998779296875,
        1100.0
      ],
      [
        1772.9156494140625,
        1689.9998779296875,
        1100.0
      ],
      [
        1885.0001220703125,
        1682.0576171875,
        1100.0
      ],
      [
        1840.0,
        1670.0,
        1100.0
      ],
      [
        1840.0,
        1670.0,
        1100.0
      ],
      [
        1794.9998779296875,
        1682.0576171875,
        1100.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1060.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1100.0
      ],
      [
        1885.0001220703125,
        1682.0576171875,
        1100.0
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1060.0
      ],
      [
        1794.9998779296875,
        1682.0576171875,
        1100.0
      ],
      [
        1787.0576171875,
        1689.9998779296875,
        1100.0
      ],
      [
        1784.2091064453125,
        1682.948974609375,
        1106.0
      ],
      [
        1781.4774169921875,
        1685.6806640625,
        1106.0
      ],
      [
        1794.0,
        1680.32568359375,
        1106.0
      ],
      [
        1794.0,
        1680.32568359375,
        1106.0
      ],
      [
        1840.0,
        1668.0,
        1106.0
      ],
      [
        1853.5225830078125,
        1666.3763427734375,
        1106.0
      ],
      [
        1849.7908935546875,
        1665.37646484375,
        1106.0
      ],
      [
        1840.0,
        1668.0,
        1106.0
      ],
      [
        1859.3182373046875,
        1664.823486328125,
        1103.0
      ],
      [
        1855.5865478515625,
        1663.8236083984375,
        1103.0
      ],
      [
        1849.7908935546875,
        1665.37646484375,
        1106.0
      ],
      [
        1853.5225830078125,
        1666.3763427734375,
        1106.0
      ],
      [
        1778.4136962890625,
        1684.5018310546875,
        1103.0
      ],
      [
        1775.681884765625,
        1687.233642578125,
        1103.0
      ],
      [
        1781.4774169921875,
        1685.6806640625,
        1106.0
      ],
      [
        1784.2091064453125,
        1682.948974609375,
        1106.0
      ],
      [
        1778.4136962890625,
        1684.5018310546875,
        1100.0
      ],
      [
        1775.681884765625,
        1687.233642578125,
        1100.0
      ],
      [
        1775.681884765625,
        1687.233642578125,
        1103.0
      ],
      [
        1778.4136962890625,
        1684.5018310546875,
        1103.0
      ],
      [
        1827.5,
        1673.34912109375,
        1115.0
      ],
      [
        1807.4998779296875,
        1678.7081298828125,
        1115.0
      ],
      [
        1807.4998779296875,
        1678.7081298828125,
        1110.0
      ],
      [
        1827.5,
        1673.34912109375,
        1110.0
      ],
      [
        1827.5,
        1673.34912109375,
        1110.0
      ],
      [
        1827.5,
        1673.34912109375,
        1115.0
      ],
      [
        1807.4998779296875,
        1678.7081298828125,
        1115.0
      ],
      [
        1807.4998779296875,
        1678.7081298828125,
        1110.0
      ],
      [
        1898.52294921875,
        1685.6810302734375,
        1106.0
      ],
      [
        1904.3182373046875,
        1687.2337646484375,
        1100.0
      ],
      [
        1904.3182373046875,
        1687.2337646484375,
        1103.0
      ],
      [
        1904.3182373046875,
        1687.2337646484375,
        1103.0
      ],
      [
        1898.52294921875,
        1685.6810302734375,
        1106.0
      ],
      [
        1888.732177734375,
        1683.0576171875,
        1106.0
      ],
      [
        1888.73193359375,
        1683.057373046875,
        1130.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1106.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1130.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1106.0
      ],
      [
        1895.6744384765625,
        1689.9998779296875,
        1106.0
      ],
      [
        1895.6744384765625,
        1689.9998779296875,
        1130.0
      ],
      [
        1888.732177734375,
        1683.0576171875,
        1106.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1106.0
      ],
      [
        1895.67431640625,
        1689.9998779296875,
        1106.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1115.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1110.0
      ],
      [
        1895.67431640625,
        1689.9998779296875,
        1115.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1115.0
      ],
      [
        1895.359130859375,
        1689.9998779296875,
        1110.0
      ],
      [
        1895.67431640625,
        1689.9998779296875,
        1110.0
      ],
      [
        1902.841796875,
        1689.9998779296875,
        1106.0
      ],
      [
        1907.0843505859375,
        1689.9998779296875,
        1103.0
      ],
      [
        1902.841796875,
        1689.9998779296875,
        1106.0
      ],
      [
        1907.0843505859375,
        1689.9998779296875,
        1100.0
      ],
      [
        1907.0843505859375,
        1689.9998779296875,
        1103.0
      ],
      [
        1810.5255126953125,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      [
        1810.5255126953125,
        1689.9998779296875,
        1115.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1110.0
      ],
      [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      [
        1810.5255126953125,
        1689.9998779296875,
        1115.0
      ],
      [
        1810.5255126953125,
        1689.9998779296875,
        1110.0
      ],
      [
        1777.158203125,
        1689.9998779296875,
        1106.0
      ],
      [
        1787.0576171875,
        1689.9998779296875,
        1106.0
      ],
      [
        1787.0576171875,
        1689.9998779296875,
        1106.0
      ],
      [
        1772.9156494140625,
        1689.9998779296875,
        1103.0
      ],
      [
        1777.158203125,
        1689.9998779296875,
        1106.0
      ],
      [
        1772.9156494140625,
        1689.9998779296875,
        1100.0
      ],
      [
        1772.9156494140625,
        1689.9998779296875,
        1103.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        385.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        380.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        380.0
      ],
      [
        1891.255615234375,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      [
        1788.74462890625,
        1689.9998779296875,
        390.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      [
        1884.1845703125,
        1689.9998779296875,
        385.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        390.0
      ],
      [
        1795.815673828125,
        1689.9998779296875,
        385.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1100.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1100.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1130.0
      ],
      [
        1660.0,
        1767.4713134765625,
        1100.0
      ],
      [
        1660.0,
        1771.8487548828125,
        1100.0
      ],
      [
        2020.0,
        1748.15087890625,
        1130.0
      ],
      [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      [
        2020.0,
        1752.5286865234375,
        1130.0
      ],
      [
        2020.0,
        1752.5286865234375,
        1100.0
      ],
      [
        2020.0,
        1748.15087890625,
        1130.0
      ],
      [
        2020.0,
        1752.5286865234375,
        1130.0
      ],
      [
        2020.0,
        1752.5286865234375,
        1100.0
      ],
      [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      [
        1917.9422607421875,
        1715.0,
        1139.9998779296875
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1131.1611328125
      ],
      [
        1917.9423828125,
        1805.0001220703125,
        1140.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1131.1612548828125
      ],
      [
        1762.0577392578125,
        1715.0,
        1139.9998779296875
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1131.1611328125
      ],
      [
        1762.0577392578125,
        1805.0,
        1140.0001220703125
      ],
      [
        1787.0577392578125,
        1830.0,
        1131.1611328125
      ],
      [
        1787.057861328125,
        1689.9998779296875,
        1140.0
      ],
      [
        1892.942138671875,
        1689.9998779296875,
        1140.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1140.0
      ],
      [
        1892.9425048828125,
        1830.0,
        1139.9998779296875
      ],
      [
        1672.354248046875,
        1817.9556884765625,
        1100.0
      ],
      [
        1672.354248046875,
        1817.9556884765625,
        1130.0
      ],
      [
        1672.354248046875,
        1817.9556884765625,
        1100.0
      ],
      [
        2007.645751953125,
        1702.044677734375,
        1100.0
      ],
      [
        2007.645751953125,
        1702.044677734375,
        1130.0
      ],
      [
        2007.645751953125,
        1702.044677734375,
        1100.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1100.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1100.0
      ],
      [
        1750.0,
        1760.0,
        1100.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1100.0
      ],
      [
        1750.0,
        1760.0,
        1100.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1100.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1100.0
      ],
      [
        1787.0576171875,
        1689.9998779296875,
        1100.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1100.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1100.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1100.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      [
        1787.0576171875,
        1830.0,
        1100.0
      ],
      [
        1892.9427490234375,
        1830.0,
        1100.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1100.0
      ],
      [
        1750.0,
        1760.0,
        1110.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1110.0
      ],
      [
        1760.3255615234375,
        1713.9998779296875,
        1110.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1110.0
      ],
      [
        1748.0,
        1760.0,
        1110.0
      ],
      [
        1750.0,
        1760.0,
        1110.0
      ],
      [
        1753.349365234375,
        1747.5,
        1115.0
      ],
      [
        1758.7083740234375,
        1727.4998779296875,
        1115.0
      ],
      [
        1753.349365234375,
        1747.5,
        1115.0
      ],
      [
        1753.349365234375,
        1747.5,
        1110.0
      ],
      [
        1758.7083740234375,
        1727.5,
        1110.0
      ],
      [
        1758.7083740234375,
        1727.4998779296875,
        1115.0
      ],
      [
        1926.65087890625,
        1772.5,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1110.0
      ],
      [
        1921.2918701171875,
        1792.5001220703125,
        1115.0
      ],
      [
        1926.65087890625,
        1772.5,
        1115.0
      ],
      [
        1908.7916259765625,
        1705.8492431640625,
        1115.0
      ],
      [
        1894.1507568359375,
        1691.2083740234375,
        1115.0
      ],
      [
        1894.1507568359375,
        1691.2083740234375,
        1110.0
      ],
      [
        1908.7916259765625,
        1705.8492431640625,
        1110.0
      ],
      [
        1895.6744384765625,
        1689.9998779296875,
        1110.0
      ],
      [
        1895.6744384765625,
        1689.9998779296875,
        1115.0
      ],
      [
        1910.15771484375,
        1704.4832763671875,
        1115.0
      ],
      [
        1910.15771484375,
        1704.4832763671875,
        1110.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1115.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1110.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1110.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1115.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1110.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1115.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1115.0
      ],
      [
        1917.9422607421875,
        1714.9998779296875,
        1110.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1115.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1110.0
      ],
      [
        1932.0001220703125,
        1760.000244140625,
        1115.0
      ],
      [
        1932.0001220703125,
        1760.000244140625,
        1110.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1110.0
      ],
      [
        1930.0001220703125,
        1760.000244140625,
        1115.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1115.0
      ],
      [
        1892.9423828125,
        1689.9998779296875,
        1110.0
      ],
      [
        1771.208251953125,
        1814.1507568359375,
        1115.0
      ],
      [
        1785.8494873046875,
        1828.7918701171875,
        1115.0
      ],
      [
        1785.8494873046875,
        1828.7918701171875,
        1110.0
      ],
      [
        1771.208251953125,
        1814.1507568359375,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1115.0
      ],
      [
        1769.8421630859375,
        1815.5167236328125,
        1115.0
      ],
      [
        1769.8421630859375,
        1815.5167236328125,
        1110.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1115.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1110.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1110.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1115.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1110.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1115.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1115.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1110.0
      ],
      [
        1787.0576171875,
        1830.0,
        1115.0
      ],
      [
        1787.0576171875,
        1830.0,
        1110.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1110.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1115.0
      ],
      [
        1919.674560546875,
        1806.000244140625,
        1110.0
      ],
      [
        1919.674560546875,
        1806.000244140625,
        1115.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1115.0
      ],
      [
        1917.9425048828125,
        1805.000244140625,
        1110.0
      ],
      [
        1917.9422607421875,
        1715.0,
        1125.0
      ],
      [
        1892.9422607421875,
        1689.9998779296875,
        1125.0
      ],
      [
        1895.6744384765625,
        1689.9998779296875,
        1125.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1125.0
      ],
      [
        1919.67431640625,
        1713.9998779296875,
        1125.0
      ],
      [
        1917.9422607421875,
        1715.0,
        1125.0
      ],
      [
        1762.0577392578125,
        1805.0,
        1125.0
      ],
      [
        1787.0577392578125,
        1830.0,
        1125.0
      ],
      [
        1784.3255615234375,
        1830.0,
        1125.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1125.0
      ],
      [
        1760.3255615234375,
        1806.0001220703125,
        1125.0
      ],
      [
        1762.0577392578125,
        1805.0,
        1125.0
      ],
      [
        1932.0001220703125,
        1760.000244140625,
        1106.0
      ],
      [
        1919.674560546875,
        1806.000244140625,
        1106.0
      ],
      [
        1917.0511474609375,
        1815.791015625,
        1106.0
      ],
      [
        1919.674560546875,
        1806.000244140625,
        1106.0
      ],
      [
        1762.9490966796875,
        1704.208984375,
        1106.0
      ],
      [
        1760.32568359375,
        1714.0,
        1106.0
      ],
      [
        1748.0,
        1760.0,
        1106.0
      ],
      [
        1760.32568359375,
        1714.0,
        1106.0
      ],
      [
        1745.37646484375,
        1769.7908935546875,
        1106.0
      ],
      [
        1748.0,
        1760.0,
        1106.0
      ],
      [
        1934.62353515625,
        1750.208984375,
        1106.0
      ],
      [
        1932.0001220703125,
        1760.000244140625,
        1106.0
      ],
      [
        1936.1763916015625,
        1744.4134521484375,
        1103.0
      ],
      [
        1934.62353515625,
        1750.208984375,
        1106.0
      ],
      [
        1912.7657470703125,
        1695.6812744140625,
        1100.0
      ],
      [
        1912.7657470703125,
        1695.6812744140625,
        1103.0
      ],
      [
        1912.7657470703125,
        1695.6812744140625,
        1103.0
      ],
      [
        1914.3187255859375,
        1701.476806640625,
        1106.0
      ],
      [
        1743.82373046875,
        1775.5869140625,
        1103.0
      ],
      [
        1745.37646484375,
        1769.7908935546875,
        1106.0
      ],
      [
        1767.23388671875,
        1824.318359375,
        1100.0
      ],
      [
        1767.23388671875,
        1824.318359375,
        1103.0
      ],
      [
        1767.23388671875,
        1824.318359375,
        1103.0
      ],
      [
        1765.6810302734375,
        1818.5228271484375,
        1106.0
      ],
      [
        1767.23388671875,
        1695.681640625,
        1103.0
      ],
      [
        1764.5018310546875,
        1698.4136962890625,
        1103.0
      ],
      [
        1762.9490966796875,
        1704.208984375,
        1106.0
      ],
      [
        1765.68115234375,
        1701.4769287109375,
        1106.0
      ],
      [
        1767.23388671875,
        1695.681640625,
        1100.0
      ],
      [
        1764.5018310546875,
        1698.4136962890625,
        1100.0
      ],
      [
        1764.5018310546875,
        1698.4136962890625,
        1103.0
      ],
      [
        1767.23388671875,
        1695.681640625,
        1103.0
      ],
      [
        1912.76611328125,
        1824.318603515625,
        1103.0
      ],
      [
        1915.4981689453125,
        1821.5865478515625,
        1103.0
      ],
      [
        1917.0511474609375,
        1815.791015625,
        1106.0
      ],
      [
        1914.319091796875,
        1818.5230712890625,
        1106.0
      ],
      [
        1912.76611328125,
        1824.318603515625,
        1100.0
      ],
      [
        1915.4981689453125,
        1821.5865478515625,
        1100.0
      ],
      [
        1915.4981689453125,
        1821.5865478515625,
        1103.0
      ],
      [
        1912.76611328125,
        1824.318603515625,
        1103.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1830.0,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        2050.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2089.50048828125,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        -0.24771343171596527,
        0.0
      ],
      "plane_d": 2410.359130859375,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2089.50048828125,
        1955.8572998046875,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2765.5,
      "bbox_min": [
        1999.2861328125,
        1838.01513671875,
        370.0
      ],
      "bbox_max": [
        2089.50048828125,
        1926.865966796875,
        1135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1999.2861328125,
        1838.01513671875,
        370.0
      ],
      "bbox_max": [
        2063.093017578125,
        1911.0142822265625,
        1125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1999.2861328125,
        1851.7933349609375,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        1911.0142822265625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        -0.7071092128753662,
        0.0
      ],
      "plane_d": 2754.99951171875,
      "bbox_min": [
        2011.71875,
        1851.7933349609375,
        720.0
      ],
      "bbox_max": [
        2029.396484375,
        1884.4395751953125,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        2014.4278564453125,
        1851.7933349609375,
        720.0
      ],
      "bbox_max": [
        2029.396484375,
        1866.761962890625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        2010.691162109375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1838.01513671875,
      "bbox_min": [
        2010.691162109375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1866.4083251953125,
      "bbox_min": [
        2010.691162109375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": 2763.4990234375,
      "bbox_min": [
        2027.628662109375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2043.18505859375,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -124.0001220703125,
      "bbox_min": [
        2041.7708740234375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2043.18505859375,
        1867.822509765625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -114.0,
      "bbox_min": [
        2027.628662109375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2034.69970703125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2763.5,
      "bbox_min": [
        2056.02197265625,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1853.571533203125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071678042411804,
        0.7070457339286804,
        0.0
      ],
      "plane_d": 144.3927001953125,
      "bbox_min": [
        2056.02197265625,
        1852.1572265625,
        1100.0
      ],
      "bbox_max": [
        2057.43603515625,
        1853.571533203125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 154.154052734375,
      "bbox_min": [
        2056.02197265625,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1845.086181640625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071102857589722,
        -0.7071033120155334,
        0.0
      ],
      "plane_d": -124.0137939453125,
      "bbox_min": [
        2040.0030517578125,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2089.50048828125,
        1926.865966796875,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        2040.0030517578125,
        1877.3685302734375,
        695.0
      ],
      "bbox_max": [
        2089.50048828125,
        1926.865966796875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070997953414917,
        0.7071138024330139,
        0.0
      ],
      "plane_d": 144.1265869140625,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2782.99951171875,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2059.094970703125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1878.0755615234375,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        -0.9686638712882996,
        0.0
      ],
      "plane_d": 2353.701904296875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1955.8572998046875,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1950.9075927734375,
        1919.3411865234375,
        370.0
      ],
      "bbox_max": [
        1990.959228515625,
        1955.8572998046875,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2740.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1952.9219970703125,
        1865.199951171875,
        370.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1929.09423828125,
        1125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1866.4083251953125,
      "bbox_min": [
        1983.354736328125,
        1865.199951171875,
        370.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1895.7532958984375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        1983.354736328125,
        1892.8450927734375,
        370.0
      ],
      "bbox_max": [
        1986.262939453125,
        1895.7532958984375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        2009.791748046875,
        1865.199951171875,
        1125.0
      ],
      "bbox_max": [
        2011.0001220703125,
        1866.4083251953125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1912.9501953125,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1912.9501953125,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7072097659111023,
        -0.7070038318634033,
        -0.0
      ],
      "plane_d": 2722.5205078125,
      "bbox_min": [
        1910.0,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1912.9501953125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        1983.800048828125,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1866.4083251953125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1866.4083251953125,
      "bbox_min": [
        1983.800048828125,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1866.4083251953125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1838.01513671875,
      "bbox_min": [
        2012.184814453125,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2017.950927734375,
        1838.01513671875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1838.01513671875,
      "bbox_min": [
        1910.0,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        2012.184814453125,
        1912.9501953125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588188946247101,
        -0.0
      ],
      "plane_d": 2379.75830078125,
      "bbox_min": [
        1971.7369384765625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1973.699951171875,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.705960750579834,
        0.7082509994506836,
        0.0
      ],
      "plane_d": 91.5787353515625,
      "bbox_min": [
        1971.7369384765625,
        1836.0584716796875,
        1100.0
      ],
      "bbox_max": [
        1973.699951171875,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        1910.0,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2012.184814453125,
        1912.9501953125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -17.1978759765625,
      "bbox_min": [
        1910.0,
        1891.7369384765625,
        1125.0
      ],
      "bbox_max": [
        1937.271728515625,
        1912.9501953125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -17.1978759765625,
      "bbox_min": [
        1910.0,
        1891.7369384765625,
        1100.0
      ],
      "bbox_max": [
        1937.271728515625,
        1912.9501953125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188946247101,
        -0.9659258723258972,
        -0.0
      ],
      "plane_d": 2323.18994140625,
      "bbox_min": [
        1910.0,
        1891.7369384765625,
        1100.0
      ],
      "bbox_max": [
        1916.0584716796875,
        1893.3603515625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.09619140625,
      "bbox_min": [
        1910.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1910.0,
        1896.0,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2710.887451171875,
      "bbox_min": [
        1910.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -752.0,
      "bbox_min": [
        1910.0,
        1830.0,
        666.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.42010071873664856,
        -0.9074774980545044,
        -0.0
      ],
      "plane_d": 2509.287353515625,
      "bbox_min": [
        1910.0,
        1830.0,
        666.0
      ],
      "bbox_max": [
        2020.0,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9086204171180725,
        -0.4176231622695923,
        -0.0
      ],
      "plane_d": 2545.69580078125,
      "bbox_min": [
        1910.0,
        1842.01318359375,
        666.0
      ],
      "bbox_max": [
        2014.4278564453125,
        1940.0999755859375,
        752.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        2004.647705078125,
        1842.01318359375,
        720.0
      ],
      "bbox_max": [
        2014.4278564453125,
        1851.7933349609375,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1099.9998779296875,
      "bbox_min": [
        1910.0,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1940.134033203125,
        1860.1337890625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1910.0,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1912.4688720703125,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9688339829444885,
        -0.24771107733249664,
        0.0
      ],
      "plane_d": -1154.953125,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2483755201101303,
        -0.9686638712882996,
        0.0
      ],
      "plane_d": 1439.6800537109375,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 138.734375,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1660.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1660.0,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071059942245483,
        -0.7071075439453125,
        0.0
      ],
      "plane_d": 90.3675537109375,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252762794495,
        0.25882139801979065,
        0.0
      ],
      "plane_d": -2193.457763671875,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.258817583322525,
        -0.9659262895584106,
        0.0
      ],
      "plane_d": 2215.62548828125,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588188946247101,
        0.0
      ],
      "plane_d": -1144.8489990234375,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1708.26318359375,
        1843.8228759765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882142782211304,
        -0.9659252762794495,
        0.0
      ],
      "plane_d": 1400.7303466796875,
      "bbox_min": [
        1756.177001953125,
        1891.7366943359375,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1756.177001953125,
        1891.7366943359375,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1756.177001953125,
        1891.7366943359375,
        1130.0
      ],
      "bbox_max": [
        1770.0,
        1924.4183349609375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1702.2049560546875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1897.7950439453125,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1702.2049560546875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1897.7950439453125,
        1100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1668.9998779296875,
        1830.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2592.253662109375,
      "bbox_min": [
        1734.9000244140625,
        1896.0,
        980.0
      ],
      "bbox_max": [
        1770.0,
        1931.0999755859375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1739.8658447265625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1770.0,
        1860.134033203125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1767.5311279296875,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1770.0,
        1832.4688720703125,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1940.0999755859375,
      "bbox_min": [
        1770.0,
        1830.0,
        370.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 2040.0,
      "bbox_min": [
        1770.0,
        1940.0999755859375,
        370.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1770.0,
        2040.0,
        390.0
      ],
      "bbox_max": [
        1910.0,
        2050.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882142782211304,
        -0.9659252762794495,
        0.0
      ],
      "plane_d": 1400.7303466796875,
      "bbox_min": [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      "bbox_max": [
        1832.501953125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        -0.25882139801979065,
        0.0
      ],
      "plane_d": 2272.19921875,
      "bbox_min": [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      "bbox_max": [
        1832.501953125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      "bbox_max": [
        1832.501953125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1828.52392578125,
        1940.0999755859375,
        1100.0
      ],
      "bbox_max": [
        1832.501953125,
        1941.094482421875,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1770.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1770.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1150.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.11574829369783401,
        -0.4319743812084198,
        0.8944274187088013
      ],
      "plane_d": -433.47149658203125,
      "bbox_min": [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1892.9425048828125,
        1850.0001220703125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574754863977432,
        -0.4319747984409332,
        0.8944273591041565
      ],
      "plane_d": -7.51824951171875,
      "bbox_min": [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1892.9425048828125,
        1850.0001220703125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2632.51806640625,
      "bbox_min": [
        1885.0001220703125,
        1830.0,
        1130.0
      ],
      "bbox_max": [
        1892.9425048828125,
        1837.9423828125,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 30.3648681640625,
      "bbox_min": [
        1787.0577392578125,
        1830.0,
        1135.5706787109375
      ],
      "bbox_max": [
        1892.9425048828125,
        1837.9423828125,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162274956703186,
        -0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -1006.0677490234375,
      "bbox_min": [
        1787.0577392578125,
        1830.0,
        1135.57080078125
      ],
      "bbox_max": [
        1799.58544921875,
        1837.9422607421875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188946247101,
        -0.9659258723258972,
        -0.0
      ],
      "plane_d": 2323.18994140625,
      "bbox_min": [
        1770.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1782.045166015625,
        1912.11669921875,
        1100.0
      ],
      "bbox_max": [
        1840.0001220703125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        -0.25882139801979065,
        0.0
      ],
      "plane_d": 2272.19921875,
      "bbox_min": [
        1832.501953125,
        1912.11669921875,
        1100.0
      ],
      "bbox_max": [
        1840.0001220703125,
        1940.0999755859375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1770.0,
        1830.0,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1927.6458740234375,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.25881925225257874,
        0.9659258127212524,
        -0.0
      ],
      "plane_d": -2273.1904296875,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1860.3529052734375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881707668304443,
        0.9659264087677002,
        -0.0
      ],
      "plane_d": -2265.119384765625,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1860.3529052734375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588171064853668,
        -0.9659263491630554,
        -6.22936750005465e-06
      ],
      "plane_d": 2263.1943359375,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1856.176513671875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1820.6817626953125,
        1832.766357421875,
        1100.0
      ],
      "bbox_max": [
        1904.318359375,
        1856.176513671875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1901.58642578125,
        1832.766357421875,
        1100.0
      ],
      "bbox_max": [
        1904.318359375,
        1835.498291015625,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1840.0001220703125,
        1837.9423828125,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1852.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        6.103515625e-05,
        0.0
      ],
      "plane_d": 1839.88720703125,
      "bbox_min": [
        1840.0001220703125,
        1841.2918701171875,
        1106.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1852.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1852.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1852.5001220703125,
        1841.2918701171875,
        1110.0
      ],
      "bbox_max": [
        1873.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1852.5001220703125,
        1846.6510009765625,
        1110.0
      ],
      "bbox_max": [
        1853.0001220703125,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882136821746826,
        -0.9659252762794495,
        6.868348805255664e-07
      ],
      "plane_d": 1310.7298583984375,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1855.176513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1775.681396484375,
        1832.7657470703125,
        1100.0
      ],
      "bbox_max": [
        1840.000244140625,
        1855.176513671875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5000041127204895,
        0.500005841255188,
        0.7070996761322021
      ],
      "plane_d": -808.4765625,
      "bbox_min": [
        1775.681396484375,
        1832.7657470703125,
        1103.0
      ],
      "bbox_max": [
        1791.37646484375,
        1846.907958984375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1791.267822265625,
        1836.9422607421875,
        1106.0
      ],
      "bbox_max": [
        1795.0,
        1839.67431640625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        0.4999989867210388,
        -0.0
      ],
      "plane_d": -2473.486083984375,
      "bbox_min": [
        1793.9998779296875,
        1837.9422607421875,
        1106.0
      ],
      "bbox_max": [
        1795.0,
        1839.67431640625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1846.6510009765625,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1106.0
      ],
      "bbox_max": [
        1794.9998779296875,
        1837.9422607421875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1784.6409912109375,
        1830.15771484375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1784.6409912109375,
        1830.15771484375,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1791.2679443359375,
        1836.9422607421875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000041127204895,
        0.500005841255188,
        0.7070996761322021
      ],
      "plane_d": -808.4765625,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1781.4769287109375,
        1834.3187255859375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056365966797,
        0.7071080207824707,
        0.0
      ],
      "plane_d": -40.3690185546875,
      "bbox_min": [
        1772.9156494140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1775.681396484375,
        1832.7657470703125,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1846.6510009765625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5001220703125,
        1846.6510009765625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1848.03857421875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5001220703125,
        1846.6510009765625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1869.4744873046875,
        1830.0,
        1110.0
      ],
      "bbox_max": [
        1872.5001220703125,
        1841.2918701171875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        1885.000244140625,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1837.9425048828125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1904.318359375,
        1830.0,
        1100.0
      ],
      "bbox_max": [
        1907.084716796875,
        1832.766357421875,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1830141395330429,
        0.6830175518989563,
        0.7071017026901245
      ],
      "plane_d": -2387.3330078125,
      "bbox_min": [
        1824.413818359375,
        1835.498291015625,
        1100.0
      ],
      "bbox_max": [
        1901.58642578125,
        1860.3529052734375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1824.413818359375,
        1835.498291015625,
        1100.0
      ],
      "bbox_max": [
        1901.58642578125,
        1860.3529052734375,
        1106.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1824.413818359375,
        1835.498291015625,
        1100.0
      ],
      "bbox_max": [
        1901.58642578125,
        1860.3529052734375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18301458656787872,
        0.6830117106437683,
        0.7071072459220886
      ],
      "plane_d": -1713.835205078125,
      "bbox_min": [
        1824.413818359375,
        1835.498291015625,
        1103.0
      ],
      "bbox_max": [
        1901.58642578125,
        1860.3529052734375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000050663948059,
        0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": -2648.4921875,
      "bbox_min": [
        1888.6236572265625,
        1835.498291015625,
        1103.0
      ],
      "bbox_max": [
        1901.58642578125,
        1846.908203125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882142782211304,
        -0.9659252762794495,
        0.0
      ],
      "plane_d": 1400.7303466796875,
      "bbox_min": [
        1770.0,
        1924.4183349609375,
        1100.0
      ],
      "bbox_max": [
        1782.045166015625,
        1927.6458740234375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1770.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1770.0,
        1830.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1884.9998779296875,
        380.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1770.0,
        1830.0,
        380.0
      ],
      "bbox_max": [
        1910.0,
        1864.29443359375,
        380.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1770.0,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.258817195892334,
        -0.9659264087677002,
        0.0
      ],
      "plane_d": 1304.5474853515625,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1843.5888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.258817195892334,
        -0.9659264087677002,
        -0.0
      ],
      "plane_d": 2256.99462890625,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1843.5888671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1795.8153076171875,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1881.7945556640625,
        1830.0,
        385.0
      ],
      "bbox_max": [
        1884.1846923828125,
        1832.39013671875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.0455932617188,
      "bbox_min": [
        1770.0,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2592.253662109375,
      "bbox_min": [
        1770.0,
        1895.74462890625,
        1059.422119140625
      ],
      "bbox_max": [
        1770.25537109375,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1909.74462890625,
        1895.4892578125,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 9.8994140625,
      "bbox_min": [
        1909.74462890625,
        1895.74462890625,
        1059.422119140625
      ],
      "bbox_max": [
        1910.0,
        1896.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -1689.9998779296875,
      "bbox_min": [
        1549.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -1.1107383670605486e-06,
        0.0
      ],
      "plane_d": -1769.998291015625,
      "bbox_min": [
        1659.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.9688323736190796,
        0.24771738052368164,
        0.0
      ],
      "plane_d": -2026.9039306640625,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.2483755201101303,
        0.9686638712882996,
        0.0
      ],
      "plane_d": -1970.0167236328125,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2350.28173828125,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1659.9998779296875,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1687.0499267578125,
        1607.0499267578125,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1687.0499267578125,
        1607.0499267578125,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2368.651123046875,
      "bbox_min": [
        1687.0499267578125,
        1607.0499267578125,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 95.939208984375,
      "bbox_min": [
        1687.0499267578125,
        1607.0499267578125,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588188946247101,
        0.9659258723258972,
        0.0
      ],
      "plane_d": -2029.322998046875,
      "bbox_min": [
        1763.941650390625,
        1626.6397705078125,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1628.26318359375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -17.1978759765625,
      "bbox_min": [
        1687.0499267578125,
        1662.7283935546875,
        1100.0
      ],
      "bbox_max": [
        1708.26318359375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        0.2588188946247101,
        0.0
      ],
      "plane_d": -2085.8916015625,
      "bbox_min": [
        1706.639892578125,
        1683.941650390625,
        1100.0
      ],
      "bbox_max": [
        1708.26318359375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 10.0408935546875,
      "bbox_min": [
        1669.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.237548828125,
      "bbox_min": [
        1734.9000244140625,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1624.0001220703125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1099.9998779296875,
      "bbox_min": [
        1739.8663330078125,
        1659.8660888671875,
        1100.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1767.53125,
        1687.531005859375,
        380.0
      ],
      "bbox_max": [
        1770.0001220703125,
        1689.9998779296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9688333868980408,
        0.24771343171596527,
        0.0
      ],
      "plane_d": 1538.40771484375,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.2483755201101303,
        0.9686638712882996,
        0.0
      ],
      "plane_d": -1055.994873046875,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 251.871337890625,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        370.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        2020.0,
        1690.0,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071075439453125,
        0.7071059942245483,
        0.0
      ],
      "plane_d": 203.504638671875,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25882139801979065,
        0.9659252762794495,
        -0.0
      ],
      "plane_d": -2136.889404296875,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659262895584106,
        -0.258817583322525,
        -0.0
      ],
      "plane_d": 2272.1943359375,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        1923.8228759765625,
        1628.26318359375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188946247101,
        0.9659258723258972,
        0.0
      ],
      "plane_d": -1046.869384765625,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        1923.8228759765625,
        1628.26318359375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        1923.8228759765625,
        1628.26318359375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1910.0,
        1595.58154296875,
        1100.0
      ],
      "bbox_max": [
        1923.8228759765625,
        1628.26318359375,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882142782211304,
        0.0
      ],
      "plane_d": 1498.7100830078125,
      "bbox_min": [
        1971.7366943359375,
        1676.177001953125,
        1100.0
      ],
      "bbox_max": [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1971.7366943359375,
        1676.177001953125,
        1100.0
      ],
      "bbox_max": [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1971.7366943359375,
        1676.177001953125,
        1130.0
      ],
      "bbox_max": [
        2004.4183349609375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1910.0,
        1622.2049560546875,
        1100.0
      ],
      "bbox_max": [
        1977.794921875,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1910.0,
        1622.2049560546875,
        1100.0
      ],
      "bbox_max": [
        1977.794921875,
        1689.9998779296875,
        1100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2592.1123046875,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1623.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1910.0,
        1659.8660888671875,
        1100.0
      ],
      "bbox_max": [
        1940.1339111328125,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1910.0,
        1687.5311279296875,
        380.0
      ],
      "bbox_max": [
        1912.46875,
        1689.9998779296875,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1579.9000244140625,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -8.719300694792764e-07,
        1.0,
        0.0
      ],
      "plane_d": -1479.998291015625,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        370.0
      ],
      "bbox_max": [
        1910.0,
        1579.9000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1769.9998779296875,
        1469.9998779296875,
        390.0
      ],
      "bbox_max": [
        1910.0,
        1480.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188946247101,
        0.9659258723258972,
        0.0
      ],
      "plane_d": -1046.869384765625,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -1499.9998779296875,
      "bbox_min": [
        1769.9998779296875,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1512.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -6.103515625e-05,
        0.0
      ],
      "plane_d": -1770.908447265625,
      "bbox_min": [
        1770.0,
        1498.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944491147994995,
        -5.459284147946164e-05,
        0.4471699595451355
      ],
      "plane_d": -1754.806396484375,
      "bbox_min": [
        1770.0,
        1498.0,
        382.0
      ],
      "bbox_max": [
        1771.0,
        1500.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.00012205541133880615,
        1.0,
        0.0
      ],
      "plane_d": -1511.7838134765625,
      "bbox_min": [
        1769.9998779296875,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1512.0,
        384.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1771.0,
      "bbox_min": [
        1771.0,
        1510.0,
        370.0
      ],
      "bbox_max": [
        1771.0,
        1512.0,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659262895584106,
        0.258817583322525,
        -0.0
      ],
      "plane_d": -2193.452880859375,
      "bbox_min": [
        1847.498046875,
        1578.9056396484375,
        1100.0
      ],
      "bbox_max": [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1847.498046875,
        1578.9056396484375,
        1100.0
      ],
      "bbox_max": [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1847.498046875,
        1578.9056396484375,
        1130.0
      ],
      "bbox_max": [
        1851.4755859375,
        1579.9000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1770.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1770.0001220703125,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.11574745178222656,
        0.4319744408130646,
        0.8944275379180908
      ],
      "plane_d": -1528.0693359375,
      "bbox_min": [
        1787.057861328125,
        1670.0,
        1130.0
      ],
      "bbox_max": [
        1892.942138671875,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574754863977432,
        0.4319747984409332,
        0.8944273591041565
      ],
      "plane_d": -1954.0206298828125,
      "bbox_min": [
        1787.057861328125,
        1670.0,
        1130.0
      ],
      "bbox_max": [
        1892.942138671875,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2458.6513671875,
      "bbox_min": [
        1787.057861328125,
        1682.0577392578125,
        1130.0
      ],
      "bbox_max": [
        1795.0,
        1689.9998779296875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2458.6513671875,
      "bbox_min": [
        1787.057861328125,
        1682.0577392578125,
        1135.57080078125
      ],
      "bbox_max": [
        1892.942138671875,
        1689.9998779296875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162274956703186,
        0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -955.4713134765625,
      "bbox_min": [
        1880.41455078125,
        1682.0577392578125,
        1135.57080078125
      ],
      "bbox_max": [
        1892.942138671875,
        1689.9998779296875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588188946247101,
        0.9659258723258972,
        0.0
      ],
      "plane_d": -2029.322998046875,
      "bbox_min": [
        1770.0001220703125,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1840.0,
        1579.9000244140625,
        1100.0
      ],
      "bbox_max": [
        1897.95556640625,
        1607.8834228515625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659262895584106,
        0.258817583322525,
        -0.0
      ],
      "plane_d": -2193.452880859375,
      "bbox_min": [
        1840.0,
        1579.9000244140625,
        1100.0
      ],
      "bbox_max": [
        1847.498046875,
        1607.8834228515625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1770.0001220703125,
        1592.354248046875,
        1060.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.25881868600845337,
        -0.9659259915351868,
        0.0
      ],
      "plane_d": 2079.32275390625,
      "bbox_min": [
        1772.9156494140625,
        1659.647216796875,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588164210319519,
        -0.9659265279769897,
        0.0
      ],
      "plane_d": 2087.3876953125,
      "bbox_min": [
        1772.9156494140625,
        1659.647216796875,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2588164508342743,
        0.9659265279769897,
        -6.2293652263178956e-06
      ],
      "plane_d": -2089.3125,
      "bbox_min": [
        1772.9156494140625,
        1663.8236083984375,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1775.681884765625,
        1663.8236083984375,
        1100.0
      ],
      "bbox_max": [
        1859.3182373046875,
        1687.233642578125,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1775.681884765625,
        1684.5018310546875,
        1100.0
      ],
      "bbox_max": [
        1778.4136962890625,
        1687.233642578125,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660261034965515,
        0.4999989867210388,
        0.0
      ],
      "plane_d": 713.4896850585938,
      "bbox_min": [
        1793.9998779296875,
        1668.0,
        1106.0
      ],
      "bbox_max": [
        1840.0,
        1682.0577392578125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1840.0,
      "bbox_min": [
        1807.0,
        1668.0,
        1106.0
      ],
      "bbox_max": [
        1840.0,
        1678.7081298828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1807.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1827.5,
        1678.7081298828125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1807.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1827.5,
        1678.7081298828125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1807.0,
        1671.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1827.5,
        1678.7081298828125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881874561309814,
        0.0
      ],
      "plane_d": 1311.4300537109375,
      "bbox_min": [
        1807.0,
        1676.84228515625,
        1110.0
      ],
      "bbox_max": [
        1807.4998779296875,
        1678.7081298828125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588164508342743,
        0.9659265279769897,
        3.250103418395156e-06
      ],
      "plane_d": -1136.8785400390625,
      "bbox_min": [
        1772.9156494140625,
        1664.823486328125,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        1840.0,
        1664.823486328125,
        1100.0
      ],
      "bbox_max": [
        1904.3182373046875,
        1687.2337646484375,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.5000044107437134,
        0.707099437713623
      ],
      "plane_d": -888.4771118164062,
      "bbox_min": [
        1888.62353515625,
        1673.0919189453125,
        1103.0
      ],
      "bbox_max": [
        1904.3182373046875,
        1687.2337646484375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1885.0,
        1680.3255615234375,
        1106.0
      ],
      "bbox_max": [
        1888.732177734375,
        1683.0576171875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": 2473.486328125,
      "bbox_min": [
        1885.0,
        1680.3255615234375,
        1106.0
      ],
      "bbox_max": [
        1886.0001220703125,
        1682.0577392578125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1772.9156494140625,
        1673.34912109375,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1885.0001220703125,
        1682.0576171875,
        1106.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1895.359130859375,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1895.359130859375,
        1689.84228515625,
        1110.0
      ],
      "bbox_max": [
        1895.67431640625,
        1689.9998779296875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1888.732177734375,
        1683.0576171875,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.5000044107437134,
        0.707099437713623
      ],
      "plane_d": -888.4771118164062,
      "bbox_min": [
        1898.52294921875,
        1685.6810302734375,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071056365966797,
        0.0
      ],
      "plane_d": -153.5062255859375,
      "bbox_min": [
        1904.3182373046875,
        1687.2337646484375,
        1100.0
      ],
      "bbox_max": [
        1907.0843505859375,
        1689.9998779296875,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1772.9156494140625,
        1673.34912109375,
        1100.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1807.4998779296875,
        1673.34912109375,
        1110.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1807.4998779296875,
        1673.34912109375,
        1110.0
      ],
      "bbox_max": [
        1831.9615478515625,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881874561309814,
        0.0
      ],
      "plane_d": 1311.4300537109375,
      "bbox_min": [
        1807.4998779296875,
        1678.7081298828125,
        1110.0
      ],
      "bbox_max": [
        1810.5255126953125,
        1689.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        1772.9156494140625,
        1682.0576171875,
        1100.0
      ],
      "bbox_max": [
        1794.9998779296875,
        1689.9998779296875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1772.9156494140625,
        1687.233642578125,
        1100.0
      ],
      "bbox_max": [
        1775.681884765625,
        1689.9998779296875,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.18301376700401306,
        -0.6830177307128906,
        0.7071016430854797
      ],
      "plane_d": 690.3807373046875,
      "bbox_min": [
        1778.4136962890625,
        1659.647216796875,
        1100.0
      ],
      "bbox_max": [
        1855.5865478515625,
        1684.5018310546875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1778.4136962890625,
        1659.647216796875,
        1100.0
      ],
      "bbox_max": [
        1855.5865478515625,
        1684.5018310546875,
        1106.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1778.4136962890625,
        1659.647216796875,
        1100.0
      ],
      "bbox_max": [
        1855.5865478515625,
        1684.5018310546875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1830122470855713,
        -0.683012068271637,
        0.7071074843406677
      ],
      "plane_d": 16.876953125,
      "bbox_min": [
        1778.4136962890625,
        1659.647216796875,
        1103.0
      ],
      "bbox_max": [
        1855.5865478515625,
        1684.5018310546875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000050663948059,
        -0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": 951.5445556640625,
      "bbox_min": [
        1778.4136962890625,
        1673.0919189453125,
        1103.0
      ],
      "bbox_max": [
        1791.37646484375,
        1684.5018310546875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588188946247101,
        0.9659258723258972,
        0.0
      ],
      "plane_d": -1046.869384765625,
      "bbox_min": [
        1897.95556640625,
        1592.354248046875,
        1100.0
      ],
      "bbox_max": [
        1910.0,
        1595.58154296875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": 784.14990234375,
      "bbox_min": [
        1790.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1890.0,
        1653.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        -0.0
      ],
      "plane_d": -2454.78759765625,
      "bbox_min": [
        1850.0,
        1618.679443359375,
        1150.0
      ],
      "bbox_max": [
        1890.0,
        1653.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": -818.7908935546875,
      "bbox_min": [
        1850.0,
        1618.679443359375,
        1150.0
      ],
      "bbox_max": [
        1890.0,
        1653.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": 2420.146484375,
      "bbox_min": [
        1850.0,
        1618.679443359375,
        1150.0
      ],
      "bbox_max": [
        1880.0,
        1653.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1653.320556640625,
      "bbox_min": [
        1860.0,
        1618.679443359375,
        1150.0
      ],
      "bbox_max": [
        1880.0,
        1653.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1618.679443359375,
      "bbox_min": [
        1860.0,
        1618.679443359375,
        1150.0
      ],
      "bbox_max": [
        1880.0,
        1618.679443359375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": -2394.825927734375,
      "bbox_min": [
        1790.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1830.0,
        1637.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        0.49999895691871643,
        0.0
      ],
      "plane_d": 740.1883544921875,
      "bbox_min": [
        1790.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1830.0,
        1637.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8660260438919067,
        -0.49999895691871643,
        -0.0
      ],
      "plane_d": 2360.18505859375,
      "bbox_min": [
        1790.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1830.0,
        1637.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660260438919067,
        -0.49999895691871643,
        0.0
      ],
      "plane_d": -774.8292846679688,
      "bbox_min": [
        1800.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1830.0,
        1637.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1637.320556640625,
      "bbox_min": [
        1800.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1820.0,
        1637.320556640625,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1602.679443359375,
      "bbox_min": [
        1800.0,
        1602.679443359375,
        1150.0
      ],
      "bbox_max": [
        1820.0,
        1602.679443359375,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1770.0001220703125,
        1623.9998779296875,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1770.0001220703125,
        1635.0,
        375.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        380.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -380.0,
      "bbox_min": [
        1770.0001220703125,
        1655.70556640625,
        380.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        380.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1770.0001220703125,
        1623.9998779296875,
        385.0
      ],
      "bbox_max": [
        1910.0,
        1689.9998779296875,
        1060.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.258817195892334,
        0.9659264087677002,
        0.0
      ],
      "plane_d": -2095.513671875,
      "bbox_min": [
        1795.815673828125,
        1676.4112548828125,
        385.0
      ],
      "bbox_max": [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588133215904236,
        0.9659274220466614,
        0.0
      ],
      "plane_d": -1143.0750732421875,
      "bbox_min": [
        1795.815673828125,
        1676.4112548828125,
        385.0
      ],
      "bbox_max": [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1795.815673828125,
        1687.6097412109375,
        385.0
      ],
      "bbox_max": [
        1884.1845703125,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1795.815673828125,
        1687.6099853515625,
        385.0
      ],
      "bbox_max": [
        1798.20556640625,
        1689.9998779296875,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1770.0001220703125,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1909.7445068359375,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": -1473.6357421875,
      "bbox_min": [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      "bbox_max": [
        1770.25537109375,
        1624.5106201171875,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.237548828125,
      "bbox_min": [
        1770.0001220703125,
        1624.0001220703125,
        1059.4224853515625
      ],
      "bbox_max": [
        1770.25537109375,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1180.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -8.719300694792764e-07,
        0.0
      ],
      "plane_d": -1659.9984130859375,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -8.719300694792764e-07,
        0.0
      ],
      "plane_d": -1559.9984130859375,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        1660.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1549.9998779296875,
        1689.9998779296875,
        390.0
      ],
      "bbox_max": [
        1560.0,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588188946247101,
        0.0
      ],
      "plane_d": -1144.8489990234375,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1100.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258817583322525,
        0.9659262895584106,
        0.0
      ],
      "plane_d": -2136.88427734375,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1100.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1100.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1658.9056396484375,
        1767.4713134765625,
        1100.0
      ],
      "bbox_max": [
        1660.0,
        1771.8487548828125,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2020.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 2120.0,
      "bbox_min": [
        2020.0,
        1690.0,
        370.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        2120.0,
        1690.0,
        390.0
      ],
      "bbox_max": [
        2130.0,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882142782211304,
        0.0
      ],
      "plane_d": 1498.7100830078125,
      "bbox_min": [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      "bbox_max": [
        2021.094482421875,
        1752.5286865234375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882139801979065,
        -0.9659252762794495,
        -0.0
      ],
      "plane_d": 2215.630859375,
      "bbox_min": [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      "bbox_max": [
        2021.094482421875,
        1752.5286865234375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      "bbox_max": [
        2021.094482421875,
        1752.5286865234375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        2020.0,
        1748.15087890625,
        1100.0
      ],
      "bbox_max": [
        2021.094482421875,
        1752.5286865234375,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -375.0,
      "bbox_min": [
        1715.0,
        1689.9998779296875,
        375.0
      ],
      "bbox_max": [
        1964.9998779296875,
        1830.0,
        380.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -379.9999694824219,
      "bbox_min": [
        1735.70556640625,
        1689.9998779296875,
        380.0
      ],
      "bbox_max": [
        1944.29443359375,
        1830.0,
        380.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1160.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1659.9998779296875,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1150.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882136821746826,
        0.0
      ],
      "plane_d": 1408.710205078125,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        -0.258819580078125,
        0.0
      ],
      "plane_d": -1234.84765625,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659257531166077,
        -0.258819580078125,
        -0.0
      ],
      "plane_d": 2319.75927734375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        -0.0
      ],
      "plane_d": -2145.892578125,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319743812084198,
        0.11574829369783401,
        0.8944273591041565
      ],
      "plane_d": -389.653564453125,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4319744408130646,
        -0.11574745178222656,
        0.8944275379180908
      ],
      "plane_d": 17.77886962890625,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319744408130646,
        0.11574745178222656,
        0.8944275379180908
      ],
      "plane_d": -1979.318115234375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319747984409332,
        -0.11574754863977432,
        0.8944273591041565
      ],
      "plane_d": -1571.887451171875,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162274956703186,
        0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -2119.1884765625,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162274956703186,
        0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -955.4713134765625,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162274956703186,
        -0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -1006.0677490234375,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162274956703186,
        -0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": 157.64959716796875,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2632.51806640625,
      "bbox_min": [
        1892.9425048828125,
        1805.0001220703125,
        1131.1612548828125
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.11574754863977432,
        0.4319747984409332,
        0.8944273591041565
      ],
      "plane_d": -1954.0206298828125,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11574754863977432,
        -0.4319747984409332,
        0.8944273591041565
      ],
      "plane_d": -7.51824951171875,
      "bbox_min": [
        1762.0577392578125,
        1689.9998779296875,
        1130.0
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2632.51806640625,
      "bbox_min": [
        1892.9425048828125,
        1805.0001220703125,
        1139.9998779296875
      ],
      "bbox_max": [
        1917.9423828125,
        1830.0,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1660.0,
        1760.0,
        1100.0
      ],
      "bbox_max": [
        1687.8834228515625,
        1817.9556884765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258817583322525,
        0.9659262895584106,
        0.0
      ],
      "plane_d": -2136.88427734375,
      "bbox_min": [
        1660.0,
        1760.0,
        1100.0
      ],
      "bbox_max": [
        1687.8834228515625,
        1767.4713134765625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659258723258972,
        -0.2588188946247101,
        -0.0
      ],
      "plane_d": 2379.75830078125,
      "bbox_min": [
        1672.354248046875,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        2020.0,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1992.11669921875,
        1702.044677734375,
        1100.0
      ],
      "bbox_max": [
        2020.0,
        1760.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882139801979065,
        -0.9659252762794495,
        -0.0
      ],
      "plane_d": 2215.630859375,
      "bbox_min": [
        1992.11669921875,
        1752.5286865234375,
        1100.0
      ],
      "bbox_max": [
        2020.0,
        1760.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -1099.9998779296875,
      "bbox_min": [
        1672.354248046875,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        2007.645751953125,
        1830.0,
        1130.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        3.2501097848580685e-06
      ],
      "plane_d": -2145.89599609375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1762.0576171875,
        1689.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1762.0576171875,
        1805.0,
        1060.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        -0.25881868600845337,
        0.0
      ],
      "plane_d": 2135.891357421875,
      "bbox_min": [
        1672.354248046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881868600845337,
        0.0
      ],
      "plane_d": 1224.849609375,
      "bbox_min": [
        1739.647216796875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258127212524,
        0.25881925225257874,
        -0.0
      ],
      "plane_d": -2329.7587890625,
      "bbox_min": [
        1739.647216796875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659265279769897,
        -0.2588164210319519,
        0.0
      ],
      "plane_d": 2143.95654296875,
      "bbox_min": [
        1739.647216796875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659264087677002,
        0.25881707668304443,
        -0.0
      ],
      "plane_d": -2321.68798828125,
      "bbox_min": [
        1743.82373046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1743.82373046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1936.1763916015625,
        1830.0,
        1130.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588164508342743,
        -0.0
      ],
      "plane_d": -2145.888427734375,
      "bbox_min": [
        1748.0,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500018298625946,
        -0.866014838218689,
        0.0
      ],
      "plane_d": 604.1543579101562,
      "bbox_min": [
        1748.0,
        1713.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1762.0577392578125,
        1760.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1748.0,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7083740234375,
        1760.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1751.4832763671875,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7083740234375,
        1747.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25881874561309814,
        0.9659259915351868,
        0.0
      ],
      "plane_d": -1234.156005859375,
      "bbox_min": [
        1751.4832763671875,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7083740234375,
        1747.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881874561309814,
        -0.9659259915351868,
        -2.3582178982906044e-05
      ],
      "plane_d": 1213.4765625,
      "bbox_min": [
        1756.84228515625,
        1726.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1758.7083740234375,
        1727.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1753.349365234375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.2588197886943817,
        0.9659256935119629,
        0.0
      ],
      "plane_d": -1234.153564453125,
      "bbox_min": [
        1753.349365234375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.25882038474082947,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1213.446533203125,
      "bbox_min": [
        1758.7083740234375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1921.2918701171875,
        1772.5,
        1110.0
      ],
      "bbox_max": [
        1926.65087890625,
        1792.5001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1805.3590087890625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2555.937255859375,
      "bbox_min": [
        1874.6409912109375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1894.1507568359375,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1910.15771484375,
        1705.8492431640625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1895.6744384765625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1910.15771484375,
        1704.4832763671875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        -0.25882017612457275,
        0.0
      ],
      "plane_d": -1360.41650390625,
      "bbox_min": [
        1874.6409912109375,
        1704.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1908.7916259765625,
        1704.4832763671875,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1908.7916259765625,
        1705.8492431640625,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000447630882263,
        0.8659996390342712,
        0.0
      ],
      "plane_d": -2444.246337890625,
      "bbox_min": [
        1917.9422607421875,
        1713.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1919.67431640625,
        1714.9998779296875,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1926.65087890625,
        1760.000244140625,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1772.5,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1760.000244140625,
      "bbox_min": [
        1930.0001220703125,
        1760.000244140625,
        1110.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1760.000244140625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659259915351868,
        0.25881874561309814,
        0.0
      ],
      "plane_d": 1311.4300537109375,
      "bbox_min": [
        1805.3590087890625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1894.1507568359375,
        1740.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659259915351868,
        -0.25881874561309814,
        0.0
      ],
      "plane_d": -1332.1356201171875,
      "bbox_min": [
        1831.9615478515625,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1894.1507568359375,
        1725.3590087890625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1185.1627197265625,
      "bbox_min": [
        1840.0,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1894.1507568359375,
        1725.3590087890625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1892.9423828125,
        1689.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1894.1507568359375,
        1691.2083740234375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2506.947509765625,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1110.0
      ],
      "bbox_max": [
        1820.0,
        1740.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1760.3255615234375,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2535.23193359375,
      "bbox_min": [
        1760.3255615234375,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1805.3590087890625,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1769.8421630859375,
        1814.1507568359375,
        1110.0
      ],
      "bbox_max": [
        1785.8494873046875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1769.8421630859375,
        1815.5167236328125,
        1110.0
      ],
      "bbox_max": [
        1784.3255615234375,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882017612457275,
        0.0
      ],
      "plane_d": 1283.142333984375,
      "bbox_min": [
        1760.3255615234375,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1805.3590087890625,
        1815.5167236328125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1110.0
      ],
      "bbox_max": [
        1771.208251953125,
        1815.5167236328125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1110.0
      ],
      "bbox_max": [
        1771.208251953125,
        1814.1507568359375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        -0.866014838218689,
        -0.0
      ],
      "plane_d": 2444.218017578125,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1110.0
      ],
      "bbox_max": [
        1762.0576171875,
        1806.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1785.8494873046875,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882038474082947,
        0.0
      ],
      "plane_d": 1311.42626953125,
      "bbox_min": [
        1785.8494873046875,
        1794.6409912109375,
        1110.0
      ],
      "bbox_max": [
        1848.03857421875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882017612457275,
        0.9659255146980286,
        0.0
      ],
      "plane_d": -1262.436767578125,
      "bbox_min": [
        1785.8494873046875,
        1794.6409912109375,
        1110.0
      ],
      "bbox_max": [
        1840.0,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1785.8494873046875,
        1828.7918701171875,
        1110.0
      ],
      "bbox_max": [
        1787.0576171875,
        1830.0,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2584.2216796875,
      "bbox_min": [
        1860.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1806.000244140625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1917.9425048828125,
        1792.5001220703125,
        1110.0
      ],
      "bbox_max": [
        1921.2918701171875,
        1806.000244140625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        0.866014838218689,
        0.0
      ],
      "plane_d": -604.1505126953125,
      "bbox_min": [
        1917.9425048828125,
        1805.000244140625,
        1110.0
      ],
      "bbox_max": [
        1919.674560546875,
        1806.000244140625,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1115.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        0.866014838218689,
        0.0
      ],
      "plane_d": -604.1505126953125,
      "bbox_min": [
        1917.9423828125,
        1760.0001220703125,
        1115.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1806.000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1760.000244140625,
      "bbox_min": [
        1930.0001220703125,
        1760.0001220703125,
        1115.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1760.000244140625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1125.0,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1115.0
      ],
      "bbox_max": [
        1919.67431640625,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1115.0
      ],
      "bbox_max": [
        1919.67431640625,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1895.6744384765625,
        1689.9998779296875,
        1115.0
      ],
      "bbox_max": [
        1919.67431640625,
        1715.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000447630882263,
        0.8659996390342712,
        0.0
      ],
      "plane_d": -2444.246337890625,
      "bbox_min": [
        1917.9422607421875,
        1713.9998779296875,
        1115.0
      ],
      "bbox_max": [
        1919.67431640625,
        1715.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1760.3255615234375,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1880.0,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1760.3255615234375,
        1805.0,
        1115.0
      ],
      "bbox_max": [
        1784.3255615234375,
        1830.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        -0.866014838218689,
        -0.0
      ],
      "plane_d": 2444.218017578125,
      "bbox_min": [
        1760.3255615234375,
        1805.0,
        1115.0
      ],
      "bbox_max": [
        1762.0577392578125,
        1806.0001220703125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        0.25882017612457275,
        -0.0
      ],
      "plane_d": -2271.46337890625,
      "bbox_min": [
        1800.0,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1880.0,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659255146980286,
        -0.25882017612457275,
        0.0
      ],
      "plane_d": -1360.41650390625,
      "bbox_min": [
        1800.0,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1880.0,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 1185.1627197265625,
      "bbox_min": [
        1800.0,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882017612457275,
        -0.9659255146980286,
        0.0
      ],
      "plane_d": 2137.62109375,
      "bbox_min": [
        1800.0,
        1720.0,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        -0.25882017612457275,
        0.0
      ],
      "plane_d": 2194.189453125,
      "bbox_min": [
        1800.0,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659255146980286,
        0.25882017612457275,
        0.0
      ],
      "plane_d": 1283.142333984375,
      "bbox_min": [
        1800.0,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882017612457275,
        0.9659255146980286,
        0.0
      ],
      "plane_d": -1262.436767578125,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        0.9659255146980286,
        -0.0
      ],
      "plane_d": -2214.89501953125,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -95.20556640625,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1794.6409912109375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2506.94775390625,
      "bbox_min": [
        1805.3590087890625,
        1725.3590087890625,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1794.6409912109375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 17.9315185546875,
      "bbox_min": [
        1805.3590087890625,
        1780.0,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1794.6409912109375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2584.2216796875,
      "bbox_min": [
        1860.0,
        1780.0,
        1115.0
      ],
      "bbox_max": [
        1874.6409912109375,
        1794.6409912109375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1125.0
      ],
      "bbox_max": [
        1919.67431640625,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1895.6744384765625,
        1689.9998779296875,
        1125.0
      ],
      "bbox_max": [
        1919.67431640625,
        1715.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000447630882263,
        0.8659996390342712,
        0.0
      ],
      "plane_d": -2444.246337890625,
      "bbox_min": [
        1917.9422607421875,
        1713.9998779296875,
        1125.0
      ],
      "bbox_max": [
        1919.67431640625,
        1715.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1760.3255615234375,
        1805.0,
        1125.0
      ],
      "bbox_max": [
        1787.0577392578125,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1760.3255615234375,
        1805.0,
        1125.0
      ],
      "bbox_max": [
        1784.3255615234375,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        -0.866014838218689,
        -0.0
      ],
      "plane_d": 2444.218017578125,
      "bbox_min": [
        1760.3255615234375,
        1805.0,
        1125.0
      ],
      "bbox_max": [
        1762.0577392578125,
        1806.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        1743.82373046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1936.1763916015625,
        1830.0,
        1110.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882136821746826,
        -6.868348805255664e-07
      ],
      "plane_d": 1408.7109375,
      "bbox_min": [
        1743.82373046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1936.1763916015625,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.683016836643219,
        -0.18301595747470856,
        0.7071020007133484
      ],
      "plane_d": -1783.119140625,
      "bbox_min": [
        1912.7657470703125,
        1695.6812744140625,
        1100.0
      ],
      "bbox_max": [
        1936.1763916015625,
        1750.208984375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071056365966797,
        0.0
      ],
      "plane_d": -153.5062255859375,
      "bbox_min": [
        1912.7657470703125,
        1695.6812744140625,
        1100.0
      ],
      "bbox_max": [
        1926.907958984375,
        1711.37646484375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000061392784119,
        -0.5000044107437134,
        0.707099437713623
      ],
      "plane_d": -888.4771118164062,
      "bbox_min": [
        1912.7657470703125,
        1695.6812744140625,
        1103.0
      ],
      "bbox_max": [
        1926.907958984375,
        1711.37646484375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        -0.2588164508342743,
        0.0
      ],
      "plane_d": -1234.8544921875,
      "bbox_min": [
        1743.82373046875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6830177307128906,
        0.18301376700401306,
        0.7071016430854797
      ],
      "plane_d": 86.1724853515625,
      "bbox_min": [
        1743.82373046875,
        1769.7908935546875,
        1100.0
      ],
      "bbox_max": [
        1767.23388671875,
        1824.318359375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056365966797,
        0.7071080207824707,
        0.0
      ],
      "plane_d": -40.3690185546875,
      "bbox_min": [
        1753.0919189453125,
        1808.62353515625,
        1100.0
      ],
      "bbox_max": [
        1767.23388671875,
        1824.318359375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000041127204895,
        0.500005841255188,
        0.7070996761322021
      ],
      "plane_d": -808.4765625,
      "bbox_min": [
        1753.0919189453125,
        1808.62353515625,
        1103.0
      ],
      "bbox_max": [
        1767.23388671875,
        1824.318359375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        3.2501097848580685e-06
      ],
      "plane_d": -2145.89599609375,
      "bbox_min": [
        1750.0,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000050663948059,
        -0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": 951.5445556640625,
      "bbox_min": [
        1762.9490966796875,
        1695.681640625,
        1100.0
      ],
      "bbox_max": [
        1767.23388671875,
        1704.208984375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1764.5018310546875,
        1695.681640625,
        1100.0
      ],
      "bbox_max": [
        1767.23388671875,
        1698.4136962890625,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        3.2501047826372087e-06
      ],
      "plane_d": 2319.75244140625,
      "bbox_min": [
        1762.0576171875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1930.0001220703125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000050663948059,
        0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": -2648.4921875,
      "bbox_min": [
        1912.76611328125,
        1815.791015625,
        1100.0
      ],
      "bbox_max": [
        1917.0511474609375,
        1824.318603515625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1912.76611328125,
        1821.5865478515625,
        1100.0
      ],
      "bbox_max": [
        1915.4981689453125,
        1824.318603515625,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": -2458.6552734375,
      "bbox_min": [
        1762.0576171875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1767.23388671875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1772.9156494140625,
        1695.681640625,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        1.87645127880387e-06
      ],
      "plane_d": 143.49984741210938,
      "bbox_min": [
        1762.0576171875,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071056365966797,
        0.0
      ],
      "plane_d": -153.5062255859375,
      "bbox_min": [
        1907.0843505859375,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1912.7657470703125,
        1695.6812744140625,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071056365966797,
        0.7071080207824707,
        0.0
      ],
      "plane_d": -40.3690185546875,
      "bbox_min": [
        1767.23388671875,
        1824.318359375,
        1100.0
      ],
      "bbox_max": [
        1772.9156494140625,
        1830.0,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 2632.51416015625,
      "bbox_min": [
        1892.9427490234375,
        1805.000244140625,
        1100.0
      ],
      "bbox_max": [
        1917.9425048828125,
        1830.0,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1907.084716796875,
        1824.318603515625,
        1100.0
      ],
      "bbox_max": [
        1912.76611328125,
        1830.0,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588164508342743,
        -0.0
      ],
      "plane_d": -2145.888427734375,
      "bbox_min": [
        1748.0,
        1689.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.500018298625946,
        -0.866014838218689,
        0.0
      ],
      "plane_d": 604.1543579101562,
      "bbox_min": [
        1748.0,
        1713.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1762.0576171875,
        1760.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1748.0,
        1760.0,
        1106.0
      ],
      "bbox_max": [
        1750.0,
        1760.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659263491630554,
        -0.2588171064853668,
        -1.3164119536668295e-06
      ],
      "plane_d": 2319.757568359375,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        0.866014838218689,
        0.0
      ],
      "plane_d": -604.1505126953125,
      "bbox_min": [
        1917.9425048828125,
        1760.000244140625,
        1106.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1806.000244140625,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1760.000244140625,
      "bbox_min": [
        1930.0001220703125,
        1760.000244140625,
        1106.0
      ],
      "bbox_max": [
        1932.0001220703125,
        1760.000244140625,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071081399917603,
        0.7071055173873901,
        -7.193062629085034e-06
      ],
      "plane_d": 143.5146026611328,
      "bbox_min": [
        1760.3255615234375,
        1689.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1919.67431640625,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        0.0
      ],
      "plane_d": -145.4384765625,
      "bbox_min": [
        1895.6744384765625,
        1689.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1919.67431640625,
        1714.9998779296875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000447630882263,
        0.8659996390342712,
        0.0
      ],
      "plane_d": -2444.246337890625,
      "bbox_min": [
        1917.9422607421875,
        1713.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1919.67431640625,
        1714.9998779296875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1787.0576171875,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        0.7071080803871155,
        0.0
      ],
      "plane_d": -32.30126953125,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1784.3255615234375,
        1830.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.500018298625946,
        -0.866014838218689,
        -0.0
      ],
      "plane_d": 2444.218017578125,
      "bbox_min": [
        1760.3255615234375,
        1805.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1762.0576171875,
        1806.0001220703125,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6830120086669922,
        0.18301266431808472,
        0.7071074843406677
      ],
      "plane_d": -2427.326171875,
      "bbox_min": [
        1915.4981689453125,
        1744.4134521484375,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1821.5865478515625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1915.4981689453125,
        1744.4134521484375,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1821.5865478515625,
        1106.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1915.4981689453125,
        1744.4134521484375,
        1100.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1821.5865478515625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.683016836643219,
        -0.18301595747470856,
        0.7071020007133484
      ],
      "plane_d": -1783.119140625,
      "bbox_min": [
        1915.4981689453125,
        1744.4134521484375,
        1103.0
      ],
      "bbox_max": [
        1940.3529052734375,
        1821.5865478515625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000050663948059,
        0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": -2648.4921875,
      "bbox_min": [
        1915.4981689453125,
        1808.6236572265625,
        1103.0
      ],
      "bbox_max": [
        1926.908203125,
        1821.5865478515625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.683012068271637,
        -0.1830122470855713,
        0.7071074843406677
      ],
      "plane_d": 730.362060546875,
      "bbox_min": [
        1739.647216796875,
        1698.4136962890625,
        1100.0
      ],
      "bbox_max": [
        1764.5018310546875,
        1775.5869140625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -1105.9998779296875,
      "bbox_min": [
        1739.647216796875,
        1698.4136962890625,
        1100.0
      ],
      "bbox_max": [
        1764.5018310546875,
        1775.5869140625,
        1106.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2448.651123046875,
      "bbox_min": [
        1739.647216796875,
        1698.4136962890625,
        1100.0
      ],
      "bbox_max": [
        1764.5018310546875,
        1775.5869140625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6830177307128906,
        0.18301376700401306,
        0.7071016430854797
      ],
      "plane_d": 86.1724853515625,
      "bbox_min": [
        1739.647216796875,
        1698.4136962890625,
        1103.0
      ],
      "bbox_max": [
        1764.5018310546875,
        1775.5869140625,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000050663948059,
        -0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": 951.5445556640625,
      "bbox_min": [
        1753.0919189453125,
        1698.4136962890625,
        1103.0
      ],
      "bbox_max": [
        1764.5018310546875,
        1711.37646484375,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588188946247101,
        0.0
      ],
      "plane_d": -1144.8489990234375,
      "bbox_min": [
        1672.354248046875,
        1817.9556884765625,
        1100.0
      ],
      "bbox_max": [
        1675.58154296875,
        1830.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659252762794495,
        0.25882142782211304,
        0.0
      ],
      "plane_d": 1498.7100830078125,
      "bbox_min": [
        2004.4183349609375,
        1689.9998779296875,
        1100.0
      ],
      "bbox_max": [
        2007.645751953125,
        1702.044677734375,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -390.0,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        -0.258817195892334,
        -0.0
      ],
      "plane_d": 2313.5634765625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": 1402.527099609375,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1923.5888671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659264087677002,
        0.258817195892334,
        0.0
      ],
      "plane_d": -2152.082275390625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659274220466614,
        -0.2588133215904236,
        0.0
      ],
      "plane_d": -1241.0543212890625,
      "bbox_min": [
        1756.4112548828125,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2464.843994140625,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 137.309326171875,
      "bbox_min": [
        1767.6097412109375,
        1689.9998779296875,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 24.1722412109375,
      "bbox_min": [
        1767.6097412109375,
        1801.79443359375,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2626.3251953125,
      "bbox_min": [
        1884.1846923828125,
        1801.7945556640625,
        385.0
      ],
      "bbox_max": [
        1912.39013671875,
        1830.0,
        390.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2592.1123046875,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2499.056640625,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 637.0455932617188,
      "bbox_min": [
        1704.19970703125,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1975.4891357421875,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1975.8001708984375,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": -1473.6357421875,
      "bbox_min": [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.5108642578125,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 10.0408935546875,
      "bbox_min": [
        1704.1998291015625,
        1689.9998779296875,
        1059.6480712890625
      ],
      "bbox_max": [
        1704.3553466796875,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        -0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 2843.666748046875,
      "bbox_min": [
        1975.4892578125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -103.09619140625,
      "bbox_min": [
        1975.6446533203125,
        1829.8446044921875,
        1059.6484375
      ],
      "bbox_max": [
        1975.800048828125,
        1830.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -1160.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1960.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1960.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1960.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1980.0,
      "bbox_min": [
        1960.0,
        1790.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1960.0,
        1810.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1980.0,
      "bbox_min": [
        1960.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1770.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1770.0,
      "bbox_min": [
        1960.0,
        1770.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1770.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1980.0,
      "bbox_min": [
        1960.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1710.0,
      "bbox_min": [
        1960.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1730.0,
      "bbox_min": [
        1960.0,
        1730.0,
        1150.0
      ],
      "bbox_max": [
        1980.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1790.0,
      "bbox_min": [
        1700.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        1790.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1810.0,
      "bbox_min": [
        1700.0,
        1790.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1720.0,
      "bbox_min": [
        1720.0,
        1790.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1810.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1770.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1770.0,
      "bbox_min": [
        1700.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1770.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1720.0,
      "bbox_min": [
        1720.0,
        1750.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1770.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1710.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -1730.0,
      "bbox_min": [
        1700.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1720.0,
      "bbox_min": [
        1720.0,
        1710.0,
        1150.0
      ],
      "bbox_max": [
        1720.0,
        1730.0,
        1160.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}